import React, { useState, useEffect } from 'react';
import { FaTrash, FaEdit } from 'react-icons/fa';
import { MdAdd } from 'react-icons/md';
import '../Styles/Questions.css';
import '../Styles/UserTypes.css';
import { useSidebar } from '../Layout/SidebarContext';

const Questions = () => {
  const { isConfigOpen } = useSidebar();

  const [solutions, setSolutions] = useState([
    {
      id: 1,
      type: 'Greenfield Landing zone solution',
      description: 'Software Solutions',
      questions: [
        { question: 'What is your experience with Software?', weightage: 10 },
        { question: 'Which software do you use?', weightage: 5 },
      ],
    },
    { id: 2, type: 'Landing zone and tower migration', description: 'Hardware Solutions', questions: [] },
  ]);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [selectedSolution, setSelectedSolution] = useState('');
  const [questions, setQuestions] = useState([]);
  const [newQuestion, setNewQuestion] = useState('');
  const [newWeightage, setNewWeightage] = useState('');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingQuestion, setEditingQuestion] = useState(null);
  const [errorPopup, setErrorPopup] = useState('');
  const [initialQuestions, setInitialQuestions] = useState([]);

  useEffect(() => {
    if (selectedSolution) {
      const solution = solutions.find((sol) => sol.type === selectedSolution);
      setQuestions(solution ? solution.questions : []);
      setInitialQuestions(solution ? solution.questions : []);
    }
  }, [selectedSolution, solutions]);

  const calculateTotalWeightage = () => {
    return questions.reduce((total, q) => total + parseFloat(q.weightage || 0), 0);
  };

  const handleAddQuestion = () => {
    if (newQuestion && newWeightage) {
      const updatedQuestions = [
        ...questions,
        { question: newQuestion, weightage: parseFloat(newWeightage) },
      ];
      setQuestions(updatedQuestions);
      setNewQuestion('');
      setNewWeightage('');
      setIsPopupOpen(false);
    }
  };

  const handleSaveQuestions = () => {
    const totalWeightage = calculateTotalWeightage();

    if (totalWeightage !== 100) {
      setErrorPopup(
        `Total weightage is ${totalWeightage}%. It must be exactly 100% before saving.`
      );
      return;
    }

    const updatedSolutions = solutions.map((sol) =>
      sol.type === selectedSolution ? { ...sol, questions } : sol
    );
    setSolutions(updatedSolutions);
    setInitialQuestions([...questions]);
    setErrorPopup('');
  };

  const handleCancelEdit = () => {
    setIsPopupOpen(false);
  };

  const handleEditQuestion = (index) => {
    setEditingQuestion({ index, ...questions[index] });
    setShowModal(true);
  };

  const handleSaveEdit = () => {
    const updatedQuestions = [...questions];
    updatedQuestions[editingQuestion.index] = {
      question: editingQuestion.question,
      weightage: parseFloat(editingQuestion.weightage),
    };
    setQuestions(updatedQuestions);
    setShowModal(false);
    setEditingQuestion(null);
  };

  const handleDeleteQuestion = (index) => {
    setDeleteIndex(index);
    setConfirmDelete(true); // Show the delete confirmation modal
  };

  const handleConfirmDelete = () => {
    setSolutions(solutions.filter((_, i) => i !== deleteIndex));
    setConfirmDelete(false); // Close the delete confirmation modal
  };

  const handleCancelDelete = () => {
    setConfirmDelete(false); // Close the delete confirmation modal
    setDeleteIndex(null);
  };
  return (
    <div className={`user-types-container ${isConfigOpen ? 'shifted-right' : ''}`}>
      <div className="heading">
        <h2>Manage Questions</h2>
      </div>

      {/* Dropdown for Solution Selection */}
      <div className="solution-selection-dropdown">
        <select onChange={(e) => setSelectedSolution(e.target.value)} value={selectedSolution}>
          <option value="">Select Solution</option>
          {solutions.map((solution) => (
            <option key={solution.id} value={solution.type}>
              {solution.type}
            </option>
          ))}
        </select>
      </div>

      {/* Questions */}
      {selectedSolution && (
        <div className="questions-container">
          <table className="user-types-table">
            <thead>
              <tr>
                <th>
                  <MdAdd size={24} color="#1e3c72" onClick={() => setIsPopupOpen(true)} />
                </th>
                <th>Question</th>
                <th>Weightage (%)</th>
              </tr>
            </thead>
            <tbody>
              {questions.length > 0 ? (
                questions.map((q, index) => (
                  <tr key={index}>
                    <td>
                      <FaEdit
                        size={15}
                        style={{ cursor: 'pointer', color: '#00bfa5' }}
                        onClick={() => handleEditQuestion(index)}
                      />
                      <FaTrash
                        size={15}
                        color="#f44336"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDeleteQuestion(index)}
                      />
                    </td>
                    <td>{q.question}</td>
                    <td>{q.weightage}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">No questions available for this solution.</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Save Button */}
          <div className="table-actions">
            <button className="save-button" onClick={handleSaveQuestions}>
              Save
            </button>
          </div>
        </div>
      )}

      {/* Add New Question Modal */}
      {isPopupOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Add New Question</h3>
            <input
              type="text"
              placeholder="Enter Question"
              value={newQuestion}
              onChange={(e) => setNewQuestion(e.target.value)}
            />
            <input
              type="number"
              placeholder="Enter Weightage"
              value={newWeightage}
              onChange={(e) => setNewWeightage(e.target.value)}
            />
            <div className="modal-actions">
              <button onClick={handleAddQuestion}>Add</button>
              <button onClick={handleCancelEdit}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Question Modal */}
      {showModal && editingQuestion && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Edit Question</h3>
            <input
              type="text"
              value={editingQuestion.question}
              onChange={(e) =>
                setEditingQuestion({ ...editingQuestion, question: e.target.value })
              }
            />
            <input
              type="number"
              value={editingQuestion.weightage}
              onChange={(e) =>
                setEditingQuestion({ ...editingQuestion, weightage: e.target.value })
              }
            />
            <div className="modal-actions">
              <button onClick={handleSaveEdit}>Save</button>
              <button onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Error Popup */}
      {errorPopup && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Error</h3>
            <p>{errorPopup}</p>
            <button onClick={() => setErrorPopup('')}>Close</button>
          </div>
        </div>
      )}

      {/* Confirm Delete Modal */}
      {confirmDelete && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Are you sure you want to delete this solution?</h3>
            <div className="modal-actions">
              <button onClick={handleConfirmDelete}>Yes, Delete</button>
              <button onClick={handleCancelDelete}>Cancel</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Questions;
